<template>
    <div>
        <el-form :inline="true" :model="form" >
            <el-form-item>
                <el-input v-model="form.keyword" placeholder="请输入关键字"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="loadData">搜索</el-button>
            </el-form-item>
        </el-form>
        <div>
            <el-table :data="tableData" v-loading="loading"  @selection-change="handleSelectionChange">
                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-if="form.pageSize===10"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.pageSize===20"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="编号" prop="serialNumber"></el-table-column>
                <el-table-column label="标题" prop="title"></el-table-column>
                <!--<el-table-column label="分类">-->
                    <!--<template slot-scope="scope">-->
                        <!--{{ scope.row.category | tableVal(changeList,'t') }}-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column label="状态" prop="status">
                    <template slot-scope="scope">
                        {{ scope.row.status | tableVal(changeStatus) }}
                    </template>
                </el-table-column>
                <el-table-column label="报告人" prop="createUser"></el-table-column>
                <el-table-column label="处理人" prop="currentHandler"></el-table-column>
                <el-table-column label="所属部门" prop="currentDepartment"></el-table-column>
                    <el-table-column label="状态" prop="status">
                        <template slot-scope="scope">
                            {{ scope.row.status | tableVal(changeStatus) }}
                        </template>
                    </el-table-column>
                <el-table-column label="创建时间" prop="createTime" width="140"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
        <div style="margin:70px 0 10px 0;display: flex;">
            <el-button type="primary" size="small" @click="submit">确定</el-button>
            <el-button type="default" size="small" @click="onCancel">取消</el-button>
        </div>
    </div>
</template>

<script>
    import services from "../../services/common.service"
    export default {
        props:{
            callback:Function
        },
        data() {
            return {
                form:{
                    keyword:"",
                    pageSize:10,
                    pageIndex:1,
                },
                total:null,
                tableData:[],
                loading:true,
                changeList:[]
            }
        },
        created() {
            this.request();
            // this.getChangeList();
        },
        computed:{
            // 变更分类id
            // changeType(){
            //     return this.$store.state.caseType.change;
            // },
            dictionary(){
                return this.$store.state.dictionary;
            },
            changeStatus(){
                return this.dictionary.change_status;
            },
            changeCategory(){
                return this.dictionary.change_category;
            }
        },
        methods: {
            // 获取变更分类
            // getChangeList(){
            //     services.categoryList(this.changeType.id).then(res => {
            //         console.log(res);
            //         this.changeList = res;
            //     })
            // },
            loadData(){
                this.form.pageIndex=1
                this.request()
            },
            request(){
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                services.getChangeList(this.form).then(res => {
                    this.tableData = res.deployTable;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            handleSelectionChange(val){
                this.multipleSelection = val;
            },
            submit(){
                if(this.multipleSelection.length == 0){
                    this.$message.error("请至少选择一个")
                }else{
                    this.callback(this.multipleSelection);
                    this.$modal.close();
                }
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },

            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
